export interface AppVersionResponse {
  version: string;
}

export async function getBackendAppVersion(): Promise<AppVersionResponse> {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const headers = {};
    const response = await fetch(`${apiUrl}/version`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.warn(
        `[ GetBackendVersionService ] API error: ${response.status}: ${response.statusText}\n${errorText}`,
      );
      return { version: "Unknown" };
    }

    if (response.status != 200) {
      console.warn(`[ GetBackendVersionService ] API not 200 error: ${response.status}: ${response.statusText}`);
      return { version: "Unknown" };
    }

    try {
      return await response.json();
    } catch (error) {
      console.warn(`[ GetBackendVersionService ] Failed to parse JSON response: ${error}`);
      return { version: "Unknown" };
    }
  } catch (error) {
    console.warn(`[ GetBackendVersionService ] Failed to fetch backend version: ${error}`);
    return { version: "Unknown" };
  }
}
